import React, { useState, useEffect } from "react";
import infocardimg from '../img/oylesine.png'
import kalemlipng from '../img/kalemlipng.png'
import './../styles/InfoCard.scss'
import Api from "../common/api";

const InfoCard = () => {
  const [datas, setData] = useState([])
  const lang = localStorage.getItem("lang");
  React.useEffect(() => {
    Api.get("/Documents/list/1").then((res) => {
      setData(res.data.items)
      // setCurrentTab(res.data.items[res.data.items.findIndex(x => x.Link == activePath)])
    });
  }, []);

  return (
    datas
      ? datas.map((data) => (
       lang == "en" ? ( 
       data.Name_EN ? (
       <div className="document-info-card">
          <div className="info-card-img">
            <img src={infocardimg} alt="asdas" style={{ width: '66', height: '86' }} />
          </div>
          <div className="document-info">
            <h4>{data.Name_EN}</h4>
            <a href={data.Link_En} target="_blank" className="document-download-btn" > Click to review </a >
          </div>
        </div>
        ):""
       ):(
        data.Name_TR ? (
         <div className="document-info-card">
          <div className="info-card-img">
            <img src={infocardimg} alt="asdas" style={{ width: '66', height: '86' }} />
          </div>
          <div className="document-info">
            <h4>{data.Name_TR}</h4>
            <a href={data.Link} target="_blank" className="document-download-btn" > İncelemek için tıklayınız </a >
          </div>
        </div>
        ):""
        )
      )) : null
  )
}

export default InfoCard
